module.exports = __webpack_public_path__ + "img/name_q.3b717771.png";